import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import colors from '../../constants/colors'
import styles from '../../constants/styles'
import { capitalizeString } from '../../lib/format'
import OptimizedImage from './OptimizedImage'

// TODO fix
// eslint-disable-next-line complexity,sonarjs/cognitive-complexity
const Avatar = ({ user, width, height, brand, restaurant }) => {
  let name
  let identity
  let imageSrc
  let alt
  let defaultSpan

  const business = brand || restaurant
  if (business) {
    ;({ name } = business)
    alt = `${name} image`
    imageSrc = business.image && business.image.path
    identity = 'business'
    defaultSpan = (
      <span
        aria-label={alt}
        className={brand ? 'fa fa-tag' : 'fa fa-map-marker-alt'}
      />
    )
  } else if (user) {
    ;({ username: name, identity, avatar: imageSrc } = user)
    alt = `@${name} profile image`
    defaultSpan = (
      <span aria-label={alt}>{capitalizeString((name && name[0]) || '?')}</span>
    )
  }

  return (
    <Container>
      {imageSrc ? (
        <Image
          src={imageSrc}
          size="xs"
          onError={(e) => {
            if (['vegan', 'vegan / plant-based'].includes(identity)) {
              e.target.src = '../../static/bg-green.png'
            } else if (identity === 'vegetarian') {
              e.target.src = '../../static/bg-seafoam.png'
            } else {
              e.target.src = '../../static/bg-blue.png'
            }
          }}
          alt={alt}
          title={name}
          identity={identity}
          width={width}
          height={height}
        />
      ) : (
        <DefaultAvatar
          aria-label="avatar"
          identity={identity}
          width={width}
          height={height}
        >
          <InnerAvatar identity={identity}>{defaultSpan}</InnerAvatar>
        </DefaultAvatar>
      )}
    </Container>
  )
}

Avatar.propTypes = {
  user: PropTypes.objectOf(PropTypes.any),
  brand: PropTypes.objectOf(PropTypes.any),
  restaurant: PropTypes.objectOf(PropTypes.any),
  width: PropTypes.string,
  height: PropTypes.string
}

Avatar.defaultProps = {
  width: '48px',
  height: '48px'
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const Image = styled(OptimizedImage)`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  object-fit: cover;
  border-radius: 50%;
  border: none;
  background-color: ${(props) => {
    switch (props.identity) {
      case 'vegan':
        return styles.colors.vegan
      case 'vegetarian':
        return styles.colors.brand
      case 'business':
        return styles.colors.white
      default:
        return colors.palette.primary.main
    }
  }};
`

const DefaultAvatar = styled.div`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  border-radius: 50%;
  border-style: solid;
  border-width: ${(props) => (props.identity === 'business' ? '1px' : '2px')};
  border-color: ${(props) => {
    switch (props.identity) {
      case 'vegan':
        return styles.colors.vegan
      case 'vegetarian':
        return styles.colors.brand
      case 'business':
        return styles.colors.darkGrey
      default:
        return colors.palette.primary.main
    }
  }};
  background-color: ${styles.colors.white};
  padding: 2px;
`

const InnerAvatar = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1em;
  color: ${(props) =>
    props.identity === 'business' ? styles.colors.black : styles.colors.white};
  background-color: ${(props) => {
    switch (props.identity) {
      case 'vegan':
        return styles.colors.vegan
      case 'vegetarian':
        return styles.colors.brand
      case 'business':
        return styles.colors.white
      default:
        return colors.palette.primary.main
    }
  }};
`

export default Avatar
